/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext } from "react";
import { Select } from "antd";
import MapPropsContext from "../MapPropsContext";
import { Title } from "./Common";
import { OPTION_MONTH, OPTION_YEAR } from "../../../utils";
import { TI_CRITERIA_MONTH, TI_CRITERIA_YEAR } from "../../../Constants";

/**
 * 기준년월
 */
const { Option } = Select;

const WidgetSelectYearMonth = () => {
  const { geojsonExtraParams, setGeojsonExtraParams } = useContext(MapPropsContext);

  const onYearChange = useCallback((date) => {
    const year = parseInt(date);
    setGeojsonExtraParams((params) => ({ ...params, year }));
  }, []);
  const onMonthChange = useCallback((date) => {
    const month = parseInt(date);
    setGeojsonExtraParams((params) => ({ ...params, month }));
  }, []);

  const { year, month } = geojsonExtraParams;

  return (
    <div>
      <Title>기준년월</Title>
      <Select defaultValue={year} onChange={onYearChange} style={{ width: "60%" }} tabIndex={TI_CRITERIA_YEAR}>
        {OPTION_YEAR().map(({ value }) => (
          <Option value={value} key={value}>
            {value}
          </Option>
        ))}
      </Select>
      <Select defaultValue={month} onChange={onMonthChange} style={{ width: "40%" }} tabIndex={TI_CRITERIA_MONTH}>
        {OPTION_MONTH().map(({ value }) => (
          <Option value={value} key={value}>
            {value}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default WidgetSelectYearMonth;
